/**
  Builds the functionality to display a modal with the bio information of a scientist when a certain element is clicked.
*/

import tingle from "tingle.js";
import "tingle.js/dist/tingle.min.css";

export const buildOurStory = () => {
  const elements = document.querySelectorAll("[js-our-story-view-bio]");
  elements.forEach((element) => {
    const name = element.dataset.name;
    const university = element.dataset.university;
    const bio = element.dataset.bio;
    element.addEventListener("click", function () {
      const modal = new tingle.modal({
        footer: false,
        stickyFooter: false,
        closeMethods: ["overlay", "button", "escape"],
        cssClass: ["our-story__scientists-modal"],
      });

      modal.setContent(`
        <div>
          <h2 class="settings-text-bold-lg">${name}</h2>
          <h3 class="settings-text-base-md tw-font-light tw-uppercase tw-mb-10">${university}</h3>
        </div>
        <p>${bio}</p>
      `);

      modal.open();

      const isKeyboardNavigation = element === document.activeElement;
      const firstFocusable = modal.modal.querySelector('button');


      if (isKeyboardNavigation && firstFocusable) {
        setTimeout(()=> {
          firstFocusable.focus();
        }, 500);

        firstFocusable.addEventListener("click", function () {
          element?.focus();
        })
      }
    });
  });
};
